import { useRef, useEffect } from "react";
import { gsap, ScrollTrigger, prefersReducedMotion } from "@/lib/animations";
import { WaveCanvas } from "@/components/WaveCanvas";
import { STATS } from "@/lib/data";

export const StatsSection = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;
    const reduced = prefersReducedMotion();

    const fmt = (n, d) =>
      n.toLocaleString("en-US", { minimumFractionDigits: d, maximumFractionDigits: d });

    const ctx = gsap.context(() => {
      section.querySelectorAll("[data-count]").forEach((el) => {
        const target = parseFloat(el.dataset.count);
        const decimals = parseInt(el.dataset.decimals || 0, 10);
        if (reduced) {
          el.textContent = fmt(target, decimals);
          return;
        }
        const obj = { v: 0 };
        gsap.to(obj, {
          v: target,
          duration: 2,
          ease: "power2.out",
          scrollTrigger: { trigger: el, start: "top 85%", once: true },
          onUpdate: () => {
            el.textContent = fmt(obj.v, decimals);
          },
        });
      });
    }, section);

    return () => ctx.revert();
  }, []);

  return (
    <section
      ref={sectionRef}
      data-testid="stats-section"
      className="relative bg-[#0B132B] text-white overflow-hidden grain"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 md:py-32 relative z-10">
        <p className="text-sm tracking-[0.2em] uppercase text-[#29ABE2] font-semibold mb-4">
          By the numbers
        </p>
        <h2 className="font-heading font-black text-4xl sm:text-5xl tracking-tighter leading-none mb-16">
          Numbers don't lie.
        </h2>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-12">
          {STATS.map((s, i) => (
            <div key={i} data-testid={`stat-item-${i}`}>
              <div className="font-heading font-black text-5xl sm:text-6xl lg:text-7xl tracking-tighter text-gradient-breeze">
                {s.prefix}
                <span data-count={s.value} data-decimals={s.decimals}>
                  0
                </span>
                {s.suffix}
              </div>
              <p className="mt-4 text-base text-white/75 font-light max-w-[240px] leading-snug">
                {s.label}
              </p>
            </div>
          ))}
        </div>
      </div>
      <WaveCanvas className="absolute bottom-0 left-0 w-full h-40" opacity={0.5} />
    </section>
  );
};
